// extracted by mini-css-extract-plugin
export var discard = "_3q-3";
export var muiTooltipTooltip = "_3q-5";
export var notificationBar = "_3q-2";
export var saveButtonHoverSlotWrapper = "_3q-4";
export var show = "_3q-1";
export var spacer = "_3q-0";